export default[
    {
        header: 'Finances',
        resource: 'user',
        action: 'read'
    },
    {
        title: 'Billing',
        icon: 'CreditCardIcon',
        resource: 'home',
        action: 'read',
        children: [
            {
                title: 'Income',
                route: 'invoices',
                resource: 'invoice',
                action: 'read',
            },
            {
                title: 'Expenses',
                route: 'expenses',
                resource: 'expense',
                action: 'read'
            },
            // {
            //     title: 'Providers',
            //     route: 'providers',
            //     resource: 'provider',
            //     action: 'read'
            // },
            {
                title: 'Cash register',
                route: 'cash',
                resource: 'cash',
                action: 'read'
            },
            // {
            //     title: 'Discounts',
            //     route: 'discounts',
            //     resource: 'discount',
            //     action: 'read'
            // }
        ]
    },
    {
        title: 'Accounts',
        route: 'accounts',
        icon: 'UsersIcon',
        resource: 'student',
        action: 'read'
    },
]
